module.exports = __webpack_public_path__ + "img/log.6d43b6c7.svg";